module.exports = __webpack_public_path__ + "static/media/part-06.afa7249c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/part-06.jpg
// module id = 937
// module chunks = 0